export default __webpack_public_path__ + "static/media/Calibre-Semibold.52e51550.ttf";